import { render } from "./MRegionalGroups.vue?vue&type=template&id=9c8de44a&scoped=true"
import script from "./MRegionalGroups.vue?vue&type=script&lang=js"
export * from "./MRegionalGroups.vue?vue&type=script&lang=js"

import "./MRegionalGroups.vue?vue&type=style&index=0&id=9c8de44a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8de44a"]])

export default __exports__